require('magnific-popup');

export default class Comment {

  constructor(fide = true, lang = Lang.locale) {
    const self = this;

    // __ data __
    this.templates = {
      parent: null,  // обертка над формой
      buttonShowReviewForm: null, // кнопка для загрузки формы отзывов в обертку
      buttonShowCommentForm: null, // кнопка для загрузки формы комментариев в
                                   // обертку
      blockComments: null, // обертка над комментариями
      form: null, // форма
      formModal: null, // модальное окно для формы
      formReview: null, // форма отзывов
      formSpam: null, // форма предупреждения о спаме
      formComment: null, // форма комментариев
      formEdit: null, // форма комментариев
      modalReview: null, // modal отзывов
      modalComment: null, // modal комментариев
      modalEdit: null,
      modal: null, // модальное окно формы
      showModalPicture: null, // кнопка для вызова модального окна добавления
                              // изображений
      showModalVideo: null, // кнопка для вызова модального окна добавления
                            // ссылок на видео
      showFormPicture: null, // кнопка перехода от формы добавления ссылок на
                             // видео к форме добавления изображений в
                             // модальном окне
      showFormVideo: null, // кнопка перехода от формы добавления ссылок на
                           // видео к форме добавления изображений в модальном
                           // окне
      formPicture: null, // форма добавления изображений
      formVideo: null, // формы добавления ссылок
      previewPicture: null, // обертка над превью изображений
      previewVideo: null, // обертка над превью видео
      success: null, // success
      forbidden: null,
    };


    if (document.getElementById('wrapper-comment-form')) {
      this.templates.parent = document.getElementById('wrapper-comment-form');

      this.templates.parent.addEventListener('click', () => {
        let button = '';
        if (self.templates.buttonShowReviewForm) {
          button = self.templates.buttonShowReviewForm;
        }
        if (self.templates.buttonShowCommentForm) {
          button = self.templates.buttonShowCommentForm;
        }
        self.id = button.dataset.id;
        self.type = button.dataset.type;

        self.comment = null;
        self.oldImage = [];
      });
    }
    if (document.getElementById('show-review-form')) {
      this.templates.buttonShowReviewForm = document.getElementById(
          'show-review-form');
    }
    if (document.getElementById('show-comment-form')) {
      this.templates.buttonShowCommentForm = document.getElementById(
          'show-comment-form');
    }
    if (document.getElementById('comments')) {
      this.templates.blockComments = document.getElementById('comments');
    }

    // данные для отправки на сервер
    this.id = null;  // индетификатор комментария(отзыва)
    this.type = null; // тип, кому пренадлежит комментарий(отзыв)
    this.link = []; // ссылки на youtube видео
    this.file = []; // изображения
    this.settings = this.templates.blockComments.dataset.settings;

    this.comment = null; // комментарий
    this.oldImage = []; // изображения уже существующего комментария
    this.commentLikesCount = 0;
    this.commentDislikesCount = 0;
    this.isPublish = true;
    this.childList = null;
    this.saveFile = false;
    this.lang = lang;

    // option
    this.reverse = this.templates.blockComments.dataset.reverse ?
        'afterBegin' :
        'beforeEnd'; // где отобразить комментарий
    this.maxImageCount = 0; // количество изображений доступное для загрузки
    this.maxVideoCount = 0; // количество ссылок на видео доступное для загрузки
    this.errorsMessage = 0;
    this.fide = fide;

    this.templates.forbidden = `<div><p>Вы не зарегистрированны! Чтобы совершить это действие вам нужно зарегистрироватся!</p></div>`;

    //__ запрашиваем формы
    let promise = new Promise((resolve, reject) => {
      axios.post('/comments/get-form', {
        type: 'review',
        lang: self.lang
      }).then(response => {
        self.templates.formReview = response.data.form;
        self.templates.modalReview = response.data.modal;
        self.templates.success = response.data.success;

        resolve(response.data);
      }).catch(errors => reject(errors.response));

      axios.post('/comments/get-form', {
        type: 'comment',
        lang: self.lang
      }).then(response => {
        self.templates.formComment = response.data.form;
        self.templates.modalComment = response.data.modal;
        self.templates.success = response.data.success;

        resolve(response.data);
      }).catch(errors => reject(errors.response));

      axios.post('/comments/get-form', {
        type: 'spam',
        lang: self.lang
      }).then(response => {
        self.templates.formSpam = response.data.form;

        resolve(response.data);
      }).catch(errors => reject(errors.response));

    }).catch(rej => console.log(rej));

    this.initSubmit(self);
    this.initInput();
    this.initCloseFormModal(self);

    // вызов формы отзывов
    if (this.templates.buttonShowReviewForm) {
      this.templates.buttonShowReviewForm.addEventListener('click', event => {
        event.preventDefault();

        Comment.setIdAndType(self, event.currentTarget);
        self.templates.parent.innerHTML = self.templates.formReview;
        self.templates.form = self.templates.parent.querySelector(
            '.comment-form');
        self.initForm(self);
      });
    }

    // вызов формы комментариев
    if (this.templates.buttonShowCommentForm) {
      this.templates.buttonShowCommentForm.addEventListener('click', event => {
        event.preventDefault();

        Comment.setIdAndType(self, event.currentTarget);
        self.templates.parent.innerHTML = self.templates.formComment;
        self.templates.form = self.templates.parent.querySelector(
            '.comment-form');
        self.initForm(self);
      });
    }

    $(document).on('click', '#success-ok',
        () => document.querySelector('.close').click());

    $(document)
        .on('mouseenter', '.comment-form .radio label', function () {
          let li = $(this).index() + 1;
          let parentForm = $(this).parents('.comment-form');
          let i = 0;

          while (i < li) {
            let l = i + 1;
            parentForm.find('.radio label:nth-child(' + l + ') i').removeClass('glyphicon-star-empty');
            parentForm.find('.radio label:nth-child(' + l + ') i').addClass('glyphicon-star');
            i++;
          }
        })
        .on('mouseleave', '.comment-form .radio label', function () {
          let li = $(this).index() + 1;
          let parentForm = $(this).parents('.comment-form');
          let i = 0;

          while (i < li) {
            let l = i + 1;
            if (parentForm.find('.radio label:nth-child(' + l + ') i').hasClass('clicked-star')) {

            }
            else {
              parentForm.find('.radio label:nth-child(' + l + ') i').addClass('glyphicon-star-empty');
              parentForm.find('.radio label:nth-child(' + l + ') i').removeClass('glyphicon-star');
            }
            i++;
          }

        });


    $(document)
        .on('click', '.comment-form .radio label', function () {
          let li = $(this).index() + 1;
          let i = 0;
          $('.comment-form .radio label i').removeClass('clicked-star');
          $('.comment-form .radio label i').removeClass('glyphicon-star');
          $('.comment-form .radio label i').addClass('glyphicon-star-empty');
          while (i < li) {
            let l = i + 1;
            $('.comment-form .radio label:nth-child(' + l + ') i').removeClass('glyphicon-star-empty');
            $('.comment-form .radio label:nth-child(' + l + ') i').addClass('glyphicon-star');
            $('.comment-form .radio label:nth-child(' + l + ') i').addClass('clicked-star');
            i++;
          }
        });

    Comment.blockCommentsEvents(self);
    // popup для картинок в комментариях
    $('.popup-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      mainClass: 'mfp-img-mobile',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1], // Will preload 0 - before current, and 1 after the
        // current image
      },
    });

    $(document).on('click', '[data-comment=close-form]', function (e) {
      e.preventDefault();
      let $this = $(this);
      $this.parent().remove();
    });
  }

  static setIdAndType(self, el) {
    if (self.id !== el.dataset.id) {
      self.id = el.dataset.id;
      self.type = el.dataset.type;
    }
  }

  submit(target, self) {
    let data = new FormData(target);
    if (self.link.length) {
      self.link = JSON.stringify(self.link);
      data.append('link', self.link);
    }

    data.append('_id', self.id);
    data.append('_type', self.type);
    data.append('settings', self.settings);
    data.append('lang', self.lang);

    if (target.querySelector('.show-modal-picture')) {
      target.querySelector('.show-modal-picture').disabled = true;
      target.querySelector('.show-modal-picture').classList.add('loading-file');
    }
    if (target.querySelector('.show-modal-video')) {
      target.querySelector('.show-modal-video').disabled = true;
      target.querySelector('.show-modal-video').classList.add('loading-file');
    }
    if (target.querySelector('button[type=submit]')) {
      target.querySelector('button[type=submit]').disabled = true;
    }

    if (self.file.length) {
      for (let file of self.file) {
        data.append('file[]', file);
        data.append('fileNames[]', location.pathname.replace(/[\D\W]/, ' ') +
            ' ' +
            document.querySelector('.comment-form input[name=name]').value);
      }
    }
    data.append('fileThumbsNames', '');

    let promise = new Promise(() => {
    });

    if (target.classList.contains('edit')) {
      promise = new Promise((resolve, reject) => {
        axios.post(`/comments/${self.id}/update`, data).then(response => {
          self.comment.insertAdjacentHTML('beforeBegin', response.data);
          self.comment.parentElement.removeChild(self.comment);
          resolve(response);
        }).catch(errors => reject(errors));
      });
    }

    if (target.classList.contains('response')) {
      promise = new Promise((resolve, reject) => {
        axios.post('/comments/store', data).then(response => {

        }).catch(errors => reject(errors));
      });
    }

    if (target.classList.contains('spam')) {
      promise = new Promise((resolve, reject) => {
        axios.post('/comments/store', data).then(response => {
          console.log('its spam');
          resolve(response);
        }).catch(errors => reject(errors));
      });
    }

    if (target.classList.contains('review') ||
        target.classList.contains('comment')) {
      promise = new Promise((resolve, reject) => {
        axios.post('/comments/store', data).then(response => {
          if (self.type === 'App\\Comment') {
            // увеличиваем счетчик у ответов на отзыв
            for (let comment of self.templates.blockComments.querySelectorAll(
                '.comment-item')) {
              if (comment.dataset.id === self.id) {
                comment.querySelector(
                    '.comment-response-list .comment-response-list-count').innerHTML++;
                new Promise((resolve, reject) => {
                  axios.post('/comments/get-children-list',
                      {
                        id: self.id,
                        type: self.type,
                        lang: self.lang
                      }).then(response => {
                    self.childList = response.data;
                    resolve(response.data);
                  }).catch(errors => reject(errors));
                }).then(res => comment.querySelector(
                    '.comment-child').innerHTML = self.childList).catch(rej => console.log(rej));

                break;
              }
            }
            resolve(response);
          }

          else if (self.templates.blockComments.querySelector(
              '#comments-list')) {
            if (self.templates.blockComments.querySelector(
                '.comments-count')) {
              self.templates.blockComments.querySelector(
                  '.comments-count').innerHTML++;
            }
            self.templates.blockComments.querySelector('#comments-list').insertAdjacentHTML(self.reverse, response.data);
            resolve(response);
          }

          else {
            // если это первый комментарий, запрашиваем список комментариев
            axios.post('/comments/get-comments-list',
                {
                  id: self.id,
                  type: self.type,
                  lang: self.lang
                }).then(response => {
              self.templates.blockComments.querySelector(
                  '.comments-count').innerHTML++;
              self.templates.blockComments.innerHTML += response.data;
              resolve(response);
            }).catch(errors => reject(errors));
          }
        }).catch(errors => reject(errors));
      });
    }

    return promise;
  }

  initModal(self) {
    self.templates.showFormPicture = self.templates.modal.querySelector(
        '.show-form-picture');
    self.templates.showFormVideo = self.templates.modal.querySelector(
        '.show-form-video');
    self.templates.formPicture = self.templates.modal.querySelector(
        '.form-picture');
    self.templates.formVideo = self.templates.modal.querySelector(
        '.form-video');
    self.templates.previewPicture = self.templates.modal.querySelector(
        '.preview-picture');
    self.templates.previewVideo = self.templates.modal.querySelector(
        '.preview-video');

    if (self.templates.formPicture &&
        self.templates.formPicture.querySelector('#preview-save-picture')) {
      for (let button of self.templates.formPicture.querySelectorAll(
          '#preview-save-picture .delete-file')) {
        self.oldImage.push(+button.dataset.id);
      }
    }

    if (self.templates.formVideo &&
        self.templates.formVideo.querySelector('#preview-save-video')) {
      let oldLink = self.templates.formVideo.querySelector(
          '#preview-save-video').dataset.link;
      oldLink = oldLink.slice(1, -1).replace(/["|']/g, '').split(',');

      oldLink.forEach(item => {
        if (item) {
          self.link.push(item);
        }
      });
    }

    // навешиваем событие input для сохранения ссылки на видео
    if (self.templates.modal.querySelectorAll('input[type=text]')) {
      for (let input of self.templates.modal.querySelectorAll(
          'input[type=text]')) {
        input.addEventListener('input', (event) => {
          let link = event.target.value;
          if (/^https:\/\/www\.youtube\.com\/embed\/.{11}/.test(link)) {
            if (!self.link.length) {
              self.link.push(link);
              Comment.previewVideo(link, self);
              event.target.value = '';
            }
            else {
              let exist = self.link.find((item) => item === link);
              if (!exist) {
                self.link.push(link);
                Comment.previewVideo(link, self);
                event.target.value = '';
              }
            }
          }

          if (/^https:\/\/www\.youtube\.com\/watch\?v=.{11}/.test(link)) {
            link = `https://www.youtube.com/embed/${link.split(/\?v=/)[1]}`;

            if (!self.link.length) {
              self.link.push(link);
              Comment.previewVideo(link, self);
              event.target.value = '';
            }
            else {
              let exist = self.link.find((item) => item === link);
              if (!exist) {
                self.link.push(link);
                Comment.previewVideo(link, self);
                event.target.value = '';
              }
            }
          }
          if (self.templates.showModalVideo) {
            Comment.calculateVideoLinks(self);
            Comment.checkPreviewLink(self);
          }
        });
      }
    }

    // удаление ссылки
    if (self.templates.previewVideo) {
      self.templates.previewVideo.addEventListener('click', event => {
        let deleteButton = '';
        if (event.target.className === 'preview-comment-video--delete') {
          deleteButton = event.target;
        }
        if (event.target.parentElement.className ===
            'preview-comment-video--delete') {
          deleteButton = event.target.parentElement;
        }

        if (deleteButton) {
          event.currentTarget.removeChild(deleteButton.parentElement);
          self.link = self.link.filter(item => {
            if (item !== deleteButton.nextElementSibling.src) {
              return item;
            }
          });

          if (self.templates.showModalVideo) {
            Comment.calculateVideoLinks(self);
            Comment.checkPreviewLink(self);
          }
        }
      });
    }

    // заполняем массив файлами и выводим превью
    if (self.templates.modal.querySelectorAll('input[type=file]')) {
      for (let input of self.templates.modal.querySelectorAll(
          'input[type=file]')) {
        input.addEventListener('change', (event) => {
          for (let file of event.target.files) {
            self.file.push(file);
            self.previewImage(file, file.name, self);
            input.value = '';
          }
          if (self.templates.showModalPicture) {
            Comment.calculatePictureFiles(self);
          }
          Comment.checkPreviewPicture(self);
        });
      }
    }

    // удаление файла
    if (self.templates.previewPicture) {
      self.templates.previewPicture.addEventListener('click', event => {
        let deleteButton = '';
        if (event.target.className === 'preview-comment-image--delete') {
          deleteButton = event.target;
        }
        if (event.target.parentElement.className ===
            'preview-comment-image--delete') {
          deleteButton = event.target.parentElement;
        }

        if (deleteButton) {
          let name = deleteButton.parentElement.dataset.name;

          event.currentTarget.removeChild(deleteButton.parentElement);
          self.file = self.file.filter(file => {
            if (file.name !== name) {
              return file;
            }
          });

          if (self.templates.showModalPicture) {
            Comment.calculatePictureFiles(self);
          }
          Comment.checkPreviewPicture(self);
        }
      });
    }

    // переход от формы ссылки к форме файлов
    if (self.templates.showFormVideo) {
      self.templates.showFormVideo.addEventListener('click', event => {
        event.target.classList.add('active');

        self.templates.showFormPicture.classList.remove('active');
        self.templates.formPicture.classList.add('sr-only');
        self.templates.formVideo.classList.remove('sr-only');
        Comment.checkPreviewLink(self);
      });
    }

    // переход от формы файлов к форме ссылок
    if (self.templates.showFormPicture) {
      self.templates.showFormPicture.addEventListener('click', event => {
        event.target.classList.add('active');

        self.templates.showFormVideo.classList.remove('active');
        self.templates.formVideo.classList.add('sr-only');
        self.templates.formPicture.classList.remove('sr-only');

        if (self.templates.showModalPicture) {
          Comment.calculatePictureFiles(self);
        }
      });
    }

    // удаление сохраненого изображения
    if (self.templates.formPicture &&
        self.templates.formPicture.querySelector('#preview-save-picture')) {
      self.templates.formPicture.querySelector('#preview-save-picture').addEventListener('click', event => {
        event.preventDefault();

        if (self.templates.formPicture.querySelector('.delete-file')) {
          let el = '';

          if (event.target.classList.contains('delete-file')) {
            el = event.target;
          }
          else if (event.target.parentElement.classList.contains(
              'delete-file')) {
            el = event.target.parentElement;
          }

          let id = +el.dataset.id;

          new Promise((resolve, reject) => {
            axios.post(`/file-upload/${id}/delete`, {});
            self.oldImage = self.oldImage.filter(n => {
              if (n !== id) {
                return n;
              }
            });
            event.currentTarget.removeChild(el.parentElement);

            if (self.templates.showModalPicture) {
              Comment.calculatePictureFiles(self);
            }
            Comment.checkPreviewPicture(self);
          });
        }
      });
    }
  }

  initSubmit(self) {
    document.addEventListener('submit', (event) => {
      if (document.querySelector('.comment-form') && event.target.classList.contains('comment-form')) {
        event.preventDefault();
        self.submit(event.target, self).then(res => {

          if (event.target.querySelector('.show-modal-picture')) {
            event.target.querySelector('.show-modal-picture').disabled = false;
            event.target.querySelector('.show-modal-picture').classList.remove('loading-file');
          }
          if (event.target.querySelector('.show-modal-video')) {
            event.target.querySelector('.show-modal-video').disabled = false;
            event.target.querySelector('.show-modal-video').classList.remove('loading-file');
          }
          if (event.target.querySelector('button[type=submit]')) {
            event.target.querySelector('button[type=submit]').disabled = false;
          }

          $(event.target).find('.radio label i').removeClass('clicked-star');
          $(event.target).find('.radio label i').removeClass('glyphicon-star');
          $(event.target).find('.radio label i').addClass('glyphicon-star-empty');

          Comment.reset(self, event.target);
          self.hideModal(self);

          setTimeout(() => {
            self.createModal(self.templates.success, 'modal-success');
            self.templates.formModal = document.querySelector(
                '#comment-modal-form');
            self.showModal();
          }, 300);

          // popup для картинок в комментариях
          $('.popup-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            mainClass: 'mfp-img-mobile',
            gallery: {
              enabled: true,
              navigateByImgClick: true,
              preload: [0, 1], // Will preload 0 - before current, and 1 after
              // the current image
            },
          });
        }).catch(res => {
          let response = res;

          if ((typeof response) === 'object') {
            response = response.response;
            res = response;
            if ((typeof response) === 'object') {
              response = response.data;
              res = response;
              if ((typeof response) === 'object') {
                response = response.errors;
                res = response;
              }
            }
          }

          if (!res) {
            Comment.reset(self, event.target);
            self.hideModal(self);
            setTimeout(() => {
              self.createModal(self.templates.success, 'modal-success');
              self.templates.formModal = document.querySelector(
                  '#comment-modal-form');
              self.showModal();
            }, 300);
          }
          else {

            if (event.target.querySelector('.show-modal-picture')) {
              event.target.querySelector(
                  '.show-modal-picture').disabled = false;
              event.target.querySelector('.show-modal-picture').classList.remove('loading-file');
            }
            if (event.target.querySelector('.show-modal-video')) {
              event.target.querySelector('.show-modal-video').disabled = false;
              event.target.querySelector('.show-modal-video').classList.remove('loading-file');
            }
            if (event.target.querySelector('button[type=submit]')) {
              event.target.querySelector(
                  'button[type=submit]').disabled = false;
            }

            $(event.target).find('.radio label i').removeClass('clicked-star');
            $(event.target).find('.radio label i').removeClass('glyphicon-star');
            $(event.target).find('.radio label i').addClass('glyphicon-star-empty');

            for (let [name, value] of Object.entries(res)) {
              self.errorsMessage++;
              let input = self.templates.form.querySelector(
                  `input[name=${name}]`);
              if (!input) {
                input = self.templates.form.querySelector(
                    `textarea[name=${name}]`);
              }

              if (input) {
                let span = input.parentElement.querySelector('.comment-errors');

                span.innerText = value[0];
              }
            }
          }
        });
      }
    });
  }

  static blockCommentsEvents(self) {
    self.templates.blockComments.addEventListener('click', event => {

      // находим нужный комментарий
      for (self.comment = event.target;
           !self.comment.classList.contains('comment-item');
           self.comment = self.comment.parentElement) {
      }

      self.file = [];
      self.link = [];

      Comment.setIdAndType(self, self.comment);

      // ответ на отзыв
      if (self.comment.querySelector('.comment-response') &&
          event.target.classList.contains('comment-response') ||
          event.target.parentElement.classList.contains('comment-response')) {

        self.createFormModal(self, 'modal-response');
        self.showModal();
      }

      // список ответов на отзыв
      if (self.comment.querySelector('.comment-response-list') &&
          event.target.classList.contains('comment-response-list') ||
          event.target.parentElement.classList.contains(
              'comment-response-list')) {

        new Promise((resolve, reject) => {
          if (!self.comment.querySelector('.comment-child').innerHTML) {
            axios.post('/comments/get-children-list',
                {
                  id: self.id,
                  type: self.type,
                  lang: self.lang
                }).then(response => {
              self.childList = response.data;

              resolve(response.data);
            }).catch(errors => reject(errors.response));
          }
          else {
            self.comment.querySelector('.comment-child').innerHTML = '';
          }
        }).then(res => self.comment.querySelector(
            '.comment-child').innerHTML = self.childList).catch(rej => console.log(rej));
      }

      //удаление коментариев
      if (self.comment.querySelector('.comment-delete') &&
          event.target.classList.contains('comment-delete') ||
          event.target.parentElement.classList.contains('comment-delete')) {

        new Promise((resolve, reject) => {
          axios.post(`/comments/get-confirm-delete`, {}).then(response => {
            self.createModal(response.data, 'modal-confirm-delete');
            self.templates.formModal = document.querySelector(
                '#comment-modal-form');
            self.showModal();

            resolve(response.data);
          }).catch(errors => reject(errors.response));
        }).then(res => {
          self.templates.formModal.querySelector('#confirm-delete-ok').addEventListener('click', () => {
            self.deleteComment(self);
            self.templates.formModal.querySelector('.close').click();
          });

          self.templates.formModal.querySelector('#confirm-delete-cancel').addEventListener('click', () => {
            self.templates.formModal.querySelector('.close').click();
          });

        }).catch(rej => console.log(rej));

      }

      // публикация комментариев
      if (self.comment.querySelector('.comment-publish') &&
          event.target.classList.contains('comment-publish') ||
          event.target.parentElement.classList.contains('comment-publish')) {

        new Promise((resolve, reject) => {
          axios.post(`/comments/${self.id}/publish`).then(response => {
            self.isPublish = response.data.is_publish;

            resolve(response.data);
          }).catch(errors => reject(errors.response));
        }).then(res => {
          if (self.isPublish) {
            self.comment.classList.remove('comment-item-published');
          }
          else {
            self.comment.classList.add('comment-item-published');
          }
        }).catch(rej => console.log(rej));
      }

      // ставим/снимаем лайк
      if (self.comment.querySelector('.comment-likes') &&
          event.target.classList.contains('comment-likes') ||
          event.target.parentElement.classList.contains('comment-likes')) {
        let buttonLike = self.comment.querySelector('.comment-likes');
        if (!buttonLike.disabled) {
          buttonLike.disabled = true;
          new Promise((resolve, reject) => {
            axios.post(`/comments/${self.id}/like`).then(response => {
              self.commentLikesCount = response.data.likes;
              self.commentDislikesCount = response.data.dislikes;

              resolve(response.data);
            }).catch(errors => reject(errors.response));
          }).then(res => {
            buttonLike.disabled = false;
            if (+self.comment.querySelector('.comment-likes-count').innerHTML >
                self.commentLikesCount) {
              self.comment.querySelector('.comment-likes-count').innerHTML--;
            }
            else if (+self.comment.querySelector(
                '.comment-likes-count').innerHTML <
                self.commentLikesCount) {
              self.comment.querySelector('.comment-likes-count').innerHTML++;
            }
            else {
            }

            if (+self.comment.querySelector(
                '.comment-dislikes-count').innerHTML >
                self.commentDislikesCount) {
              self.comment.querySelector('.comment-dislikes-count').innerHTML--;
            }
            else if (+self.comment.querySelector(
                '.comment-dislikes-count').innerHTML <
                self.commentDislikesCount) {
              self.comment.querySelector('.comment-dislikes-count').innerHTML++;
            }
          }).catch(rej => console.log(rej));
        }
      }

      // ставим/снимаем лайк
      if (self.comment.querySelector('.comment-dislikes') &&
          event.target.classList.contains('comment-dislikes') ||
          event.target.parentElement.classList.contains('comment-dislikes')) {
        let buttonDislike = self.comment.querySelector('.comment-dislikes');

        if (!buttonDislike.disabled) {
          buttonDislike.disabled = true;
          new Promise((resolve, reject) => {
            axios.post(`/comments/${self.id}/dislike`).then(response => {
              self.commentLikesCount = response.data.likes;
              self.commentDislikesCount = response.data.dislikes;

              resolve(response.data);
            }).catch(errors => reject(errors.response));
          }).then(res => {
            buttonDislike.disabled = false;
            if (+self.comment.querySelector('.comment-likes-count').innerHTML >
                self.commentLikesCount) {
              self.comment.querySelector('.comment-likes-count').innerHTML--;
            }
            else if (+self.comment.querySelector(
                '.comment-likes-count').innerHTML <
                self.commentLikesCount) {
              self.comment.querySelector('.comment-likes-count').innerHTML++;
            }
            else {
            }

            if (+self.comment.querySelector(
                '.comment-dislikes-count').innerHTML ===
                self.commentDislikesCount) {
              self.comment.querySelector('.comment-dislikes-count').innerHTML++;
            }
            else if (+self.comment.querySelector(
                '.comment-dislikes-count').innerHTML >
                self.commentDislikesCount) {
              self.comment.querySelector('.comment-dislikes-count').innerHTML--;
            }
            else if (+self.comment.querySelector(
                '.comment-dislikes-count').innerHTML <
                self.commentDislikesCount) {
              self.comment.querySelector('.comment-dislikes-count').innerHTML++;
            }
          }).catch(rej => {
            if (+rej.status === 403) {
              self.createFormModal(self, 'Forbidden', false);
              self.showModal();
              buttonDislike.disabled = false;
            }
          });
        }
      }

      // отправляю отметку о спаме
      if (self.comment.querySelector('.comment-spam') &&
          event.target.classList.contains('comment-spam') ||
          event.target.parentElement.classList.contains('comment-spam')) {

        self.createFormModal(self, 'modal-spam');
        self.showModal();
      }

      // редактирование отзыва
      // if (self.comment.querySelector('.comment-edit') &&
      //     event.target.classList.contains('comment-edit') ||
      //     event.target.parentElement.classList.contains('comment-edit')) {
      //
      //   new Promise((resolve, reject) => {
      //     axios.post('/comments/get-form', {
      //       id: self.id,
      //       type: 'edit'
      //     }).then(response => {
      //       self.templates.modalEdit = response.data.modal;
      //       self.templates.formEdit = response.data.form;
      //       resolve(response.data);
      //     }).catch(errors => reject(errors));
      //   }).then(res => {
      //     self.createFormModal(self, 'modal-edit');
      //     self.showModal();
      //     $(document).on('hidden.bs.modal', '.modal', function () {
      //       $('.modal:visible').length &&
      //       $(document.body).addClass('modal-open');
      //     });
      //     $('.comment-form.edit .radio label input[checked]').parents('label').click();
      //
      //     if (self.templates.showModalVideo) {
      //       Comment.calculateVideoLinks(self);
      //     }
      //   }).catch(rej => console.log(rej));
      // }
    });
  }

  static calculateVideoLinks(self) {
    // счетчик добавленных видео
    if (self.link.length &&
        !self.templates.showModalVideo.querySelector('.video-count')) {
      self.templates.showModalVideo.innerHTML += `<span class="badge video-count">${self.link.length}</span>`;
    }
    else if (self.link.length &&
        self.templates.showModalVideo.querySelector('.video-count')) {
      self.templates.showModalVideo.querySelector(
          '.video-count').innerText = self.link.length;
    }
    else if (!self.link.length &&
        self.templates.showModalVideo.querySelector('.video-count')) {
      self.templates.showModalVideo.removeChild(
          self.templates.showModalVideo.querySelector('.video-count'));
    }
  }

  static calculatePictureFiles(self) {
    // счетчик загружаемых файлов
    if ((self.oldImage.length + self.file.length) &&
        !self.templates.showModalPicture.querySelector('.picture-count')) {
      self.templates.showModalPicture.innerHTML += `<span class="badge picture-count">${(self.oldImage.length +
          self.file.length)}</span>`;
    }
    else if ((self.oldImage.length + self.file.length) &&
        self.templates.showModalPicture.querySelector('.picture-count')) {
      self.templates.showModalPicture.querySelector(
          '.picture-count').innerText = (self.oldImage.length +
          self.file.length);
    }
    else if (!(self.oldImage.length + self.file.length) &&
        self.templates.showModalPicture.querySelector('.picture-count')) {
      self.templates.showModalPicture.removeChild(
          self.templates.showModalPicture.querySelector('.picture-count'));
    }
  }

  static checkPreviewLink(self) {
    let style = window.getComputedStyle(self.templates.previewVideo.nextElementSibling);
    if (self.link.length && !self.templates.previewVideo.children.length) {
      self.link.forEach(item => Comment.previewVideo(item, self));
    }
    if (self.maxVideoCount <= self.link.length) {
      if (style.display !== 'none') {
        self.templates.previewVideo.nextElementSibling.style.display = 'none';
      }
    }
    else {
      if (style.display !== 'block') {
        self.templates.previewVideo.nextElementSibling.style.display = 'block';
      }
    }
  }

  static checkPreviewPicture(self) {
    let style = window.getComputedStyle(
        self.templates.previewPicture.nextElementSibling);
    if (self.maxImageCount <= (self.oldImage.length + self.file.length)) {
      if (style.display !== 'none') {
        self.templates.previewPicture.nextElementSibling.style.display = 'none';
      }
    }
    else {
      if (style.display !== 'block') {
        self.templates.previewPicture.nextElementSibling.style.display = 'block';
      }
    }
  }

  static reset(self, form) {
    self.comment = null;
    self.oldImage = [];
    self.link = [];
    self.file = [];
    self.id = null;
    self.type = null;
    self.oldImage = [];
    self.errorsMessage = 0;

    form.reset();

    if (self.templates.form.parentElement.id === 'wrapper-comment-form' &&
        !self.fide) {
      self.templates.parent.innerHTML = '';
    }

    if (self.templates.showModalPicture) {
      Comment.calculatePictureFiles(self);
    }

    if (self.templates.showModalVideo) {
      Comment.calculateVideoLinks(self);
    }

  }

  previewImage(file, name, self) {

    const fileRider = new FileReader();
    let previewList = [];

    fileRider.addEventListener('load', event => {
      previewList.push(`
              <div class="preview-slide" data-name="${name}">
                <span class="preview-comment-image--delete">
                <i class="glyphicon glyphicon-trash"></i>
                </span>
                <img src="${event.target.result}">
              </div>
            `);
      for (let image of previewList) {
        self.templates.previewPicture.innerHTML += image;
      }
    }, false);

    fileRider.readAsDataURL(file);
  }

  static previewVideo(link, self) {
    console.log(link, 'ifr');
    self.templates.previewVideo.innerHTML += `
                              <div>
                                <span class="preview-comment-video--delete">
                                  <i class="glyphicon glyphicon-trash"></i>
                                </span>
                                <iframe src="${link}" frameborder="0"></iframe>
                              </div>`;
  }

  initInput() {
    let self = this;
    document.addEventListener('input', (e) => {
      if (document.querySelector('.comment-form') && e.target.form.classList.contains('comment-form')) {
        let span = e.target.parentElement.querySelector('.comment-errors');
        if (span) {
          if (span.innerText) {
            span.innerText = '';
            self.errorsMessage--;
          }
        }
      }
    });
  }

  deleteComment(self) {
    new Promise((resolve, reject) => {
      axios.post(`/comments/${self.id}/delete`).then(response => resolve(response.data)).catch(errors => reject(errors.response));
    }).then(res => {
      self.comment.parentElement.removeChild(self.comment);
      self.templates.blockComments.querySelector('.comments-count').innerHTML--;
    }).catch(rej => console.log(rej));
  }

  createModal(form, type, id = 'comment-modal-form') {
    if (document.querySelector('#' + id)) {
      let modal = document.querySelector('#' + id);

      if (id === 'comment-modal-form' &&
          !modal.querySelector('.modal-content').classList.contains(type)) {
        let modalContent = modal.querySelector('.modal-content');
        modalContent.className = '';
        modalContent.classList.add('modal-content');
        modalContent.classList.add(type);
      }

      if (type) {
        let titleModal = modal.querySelector('.modal-title');
        if (type === 'modal-response') {
          titleModal.innerText = Lang.get('js.comments.respond');
        }
        if (type === 'modal-edit') {
          titleModal.innerText = Lang.get('js.comments.edit');
        }
        if (type === 'modal-spam') {
          titleModal.innerText = Lang.get('js.comments.complain');
        }
      }

      modal.querySelector('.modal-body').innerHTML = form;
      return false;
    }

    let modal = document.createElement('div');
    modal.classList.add('modal');
    modal.classList.add('fade');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('tabindex', '-1');
    modal.id = id;

    let modalDialog = document.createElement('div');
    modalDialog.classList.add('modal-dialog');
    modalDialog.setAttribute('role', 'document');
    modal.appendChild(modalDialog);

    let modalContent = document.createElement('div');
    modalContent.classList.add('modal-content');
    modalContent.classList.add(type);
    modalDialog.appendChild(modalContent);

    let modalHeader = document.createElement('div');
    modalHeader.classList.add('modal-header');
    modalContent.appendChild(modalHeader);

    let buttonCloseHeader = document.createElement('button');
    buttonCloseHeader.classList.add('close');
    if (id === 'comment-modal-form') {
      buttonCloseHeader.classList.add('close-form');
    }
    buttonCloseHeader.type = 'button';
    buttonCloseHeader.dataset.dismiss = 'modal';
    buttonCloseHeader.setAttribute('aria-label', 'close');
    modalHeader.appendChild(buttonCloseHeader);

    if (type) {
      let titleModal = document.createElement('h4');
      titleModal.className = 'modal-title';
      if (id === 'comment-modal-form') {
        if (type === 'modal-response') {
          titleModal.innerText = Lang.get('js.comments.respond');
        }

        if (type === 'modal-edit') {
          titleModal.innerText = Lang.get('js.comments.edit');
        }

        if (type === 'modal-spam') {
          titleModal.innerText = Lang.get('js.comments.complain');
        }
      }
      else {
        titleModal.innerText = Lang.get('js.comments.add_media');
      }
      modalHeader.appendChild(titleModal);
    }

    let spanInButtonClose = document.createElement('span');
    spanInButtonClose.setAttribute('aria-hidden', 'true');
    spanInButtonClose.innerText = 'x';
    buttonCloseHeader.appendChild(spanInButtonClose);

    let modalBody = document.createElement('div');
    modalBody.classList.add('modal-body');
    modalBody.innerHTML = form;
    modalContent.appendChild(modalBody);

    if (id !== 'comment-modal-form') {
      let modalFooter = document.createElement('div');
      modalFooter.classList.add('modal-footer');
      modalContent.appendChild(modalFooter);

      let buttonCloseFooter = buttonCloseHeader.cloneNode(true);
      buttonCloseFooter.classList.remove('close');
      buttonCloseFooter.classList.add('btn');
      buttonCloseFooter.classList.add('btn-cancel-comment-attributes');
      buttonCloseFooter.classList.add('btn-default');
      buttonCloseFooter.innerHTML = 'Отменить';

      let buttonSaveFooter = buttonCloseFooter.cloneNode(true);
      buttonSaveFooter.classList.remove('btn-default');
      buttonSaveFooter.classList.remove('btn-cancel-comment-attributes');
      buttonSaveFooter.classList.add('btn-primary');
      buttonSaveFooter.classList.add('btn-save-comment-attributes');
      buttonSaveFooter.innerHTML = 'Сохранить';
      modalFooter.appendChild(buttonSaveFooter);

      modalFooter.appendChild(buttonCloseFooter);
    }

    if (id !== 'comment-attributes-modal' &&
        document.querySelector('#comment-attributes-modal')) {
      document.querySelector('#comment-attributes-modal').insertAdjacentElement('beforeBegin', modal);
    }
    else {
      document.body.appendChild(modal);
    }
  }

  showModal(id = '#comment-modal-form') {
    $(id).modal('show');
  }

  hideModal(self) {
    if (self.templates.formModal) {
      self.templates.formModal.querySelector('.close').click();
      setTimeout(() => {
        document.body.removeChild(self.templates.formModal);
      }, 300);
    }
  }

  initCloseFormModal(self) {
    document.addEventListener('click', event => {
      if (event.target.classList.contains('close') ||
          event.target.parentElement.classList.contains('close') ||
          event.target.classList.contains('modal')) {
        if (self.templates.formVideo &&
            self.templates.formVideo.classList.contains('sr-only')) {
          self.templates.formVideo.classList.remove('sr-only');
        }
        if (self.templates.formPicture &&
            self.templates.formPicture.classList.contains('sr-only')) {
          self.templates.formPicture.classList.remove('sr-only');
        }
        if (self.templates.showFormPicture &&
            self.templates.showFormPicture.classList.contains('active')) {
          self.templates.showFormPicture.classList.remove('active');
        }
        if (self.templates.showFormVideo &&
            self.templates.showFormVideo.classList.contains('active')) {
          self.templates.showFormVideo.classList.remove('active');
        }
        if (!self.saveFile) {
          self.file = [];
          self.link = [];

          if (self.templates.showModalPicture) {
            Comment.calculatePictureFiles(self);
          }
          if (self.templates.showModalVideo) {
            Comment.calculateVideoLinks(self);
          }
        }
      }

      // if(event.target.classList.contains('close-form') ||
      //   event.target.parentElement.classList.contains('close-form')) {
      //   self.hideModal(self);
      // }

      if (event.target.classList.contains('btn-save-comment-attributes') ||
          event.target.parentElement.classList.contains(
              'btn-save-comment-attributes')) {
        self.saveFile = true;

        if (self.templates.showModalPicture) {
          Comment.calculatePictureFiles(self);
        }
        if (self.templates.showModalVideo) {
          Comment.calculateVideoLinks(self);
        }
      }

      if (event.target.classList.contains('btn-cancel-comment-attributes') ||
          event.target.parentElement.classList.contains(
              'btn-cancel-comment-attributes')) {
        self.saveFile = false;
        self.file = [];
        self.link = [];

        if (self.templates.showModalPicture) {
          Comment.calculatePictureFiles(self);
        }
        if (self.templates.showModalVideo) {
          Comment.calculateVideoLinks(self);
        }
      }
    });
  }

  initForm(self) {
    if (self.templates.form) {
      self.templates.showModalPicture = self.templates.form.querySelector(
          '.show-modal-picture');
      self.templates.showModalVideo = self.templates.form.querySelector(
          '.show-modal-video');
    }


    if (self.templates.showModalPicture) {
      self.maxImageCount = +self.templates.showModalPicture.dataset.count;
    }

    if (self.templates.showModalVideo) {
      self.maxVideoCount = +self.templates.showModalVideo.dataset.count;
    }

    // модальное окно для добавления картинок
    if (self.templates.showModalPicture) {
      self.templates.showModalPicture.addEventListener('click', event => {
        event.preventDefault();

        self.createAttributesModal(self,
            $(event.currentTarget).parents('form'));
        self.showModal('#comment-attributes-modal');

        if (self.templates.showFormPicture) {
          self.templates.showFormPicture.classList.add('active');

          if (self.templates.formVideo &&
              !self.templates.formVideo.classList.contains('sr-only')) {
            self.templates.formVideo.classList.add('sr-only');
          }
        }
        Comment.checkPreviewPicture(self);
      });
    }

    // модальное окно для добавления видео
    if (self.templates.showModalVideo) {
      self.templates.showModalVideo.addEventListener('click', event => {
        event.preventDefault();

        self.createAttributesModal(self,
            $(event.currentTarget).parents('form'));
        self.showModal('#comment-attributes-modal');

        if (self.templates.showFormVideo) {
          self.templates.showFormVideo.classList.add('active');

          if (self.templates.formPicture &&
              !self.templates.formPicture.classList.contains('sr-only')) {
            self.templates.formPicture.classList.add('sr-only');
          }
        }
        Comment.checkPreviewLink(self);
      });
    }
  }

  createFormModal(self, type, initForm = true) {
    var body = self.templates.formComment;
    if (type === 'modal-response') {
      body = self.templates.formComment;
    }
    if (type === 'modal-spam') {
      body = self.templates.formSpam;
    }
    if (type === 'modal-edit') {
      body = self.templates.formEdit;
    }
    if (type === 'Forbidden') {
      body = self.templates.forbidden;
    }

    self.createModal(body, type);
    self.templates.form = document.querySelector(
        '#comment-modal-form .comment-form');
    self.templates.formModal = document.querySelector('#comment-modal-form');
    if (initForm) {
      self.initForm(self);
    }
  }

  createAttributesModal(self, $el) {
    var body = self.templates.modalComment;
    if ($el.hasClass('review')) {
      console.log('rew');
      body = self.templates.modalReview;
    }
    if ($el.hasClass('comment')) {
      console.log('com');
      body = self.templates.modalComment;
    }

    if ($el.hasClass('edit')) {
      console.log('edit');
      body = self.templates.modalEdit;
    }

    self.createModal(body, 'comment-modal', 'comment-attributes-modal');
    self.templates.modal = document.querySelector('#comment-attributes-modal');
    self.initModal(self);

    if (self.file.length) {
      for (let file of self.file) {
        self.previewImage(file, file.name, self);
      }
    }

    if (self.link.length) {
      for (let link of self.link) {
        Comment.previewVideo(link, self);
      }
    }
  }

}


// WEBPACK FOOTER //
// ./resources/js/core/Comment.js